import { memo } from 'react';

import { Flex, Separator } from '@/components/core';
import {
  ExportMakeConfiguration,
  ExportN8NConfiguration,
  ExportPanelHeader,
  ExportPowerAutomateConfiguration,
  ExportWebhookConfiguration,
  ExportZapierConfiguration,
} from '@/components/flow';
import { ExportExcelConfiguration } from '@/connectors/msgraph';
import {
  EXPORT_TO_MAKE_FUNCTION_ID,
  EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID,
  EXPORT_TO_N8N_FUNCTION_ID,
  EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID,
  EXPORT_TO_WEBHOOK_FUNCTION_ID,
  EXPORT_TO_ZAPIER_FUNCTION_ID,
} from '@/constants';
import { toActionId, useGetAction } from '@/hooks/api';
import { TriggerProvider } from '@/store';

export type ExportPanelProps = {
  agentId: string;
  actionId: string;
};

const IExportPanel = ({ agentId, actionId }: ExportPanelProps) => {
  const { data: action } = useGetAction(toActionId(actionId));

  if (!action) return null;

  return (
    /* Force remount of component when agentId or actionId changes */
    <Flex col key={`${agentId}/${actionId}`} className="w-full">
      <TriggerProvider action={action}>
        <ExportPanelHeader className="p-4" actionId={actionId} />
        <Separator orientation="horizontal" />
        {action.functionId === EXPORT_TO_MAKE_FUNCTION_ID ? <ExportMakeConfiguration /> : null}
        {action.functionId === EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID ? <ExportExcelConfiguration /> : null}
        {action.functionId === EXPORT_TO_N8N_FUNCTION_ID ? <ExportN8NConfiguration /> : null}
        {action.functionId === EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID ? <ExportPowerAutomateConfiguration /> : null}
        {action.functionId === EXPORT_TO_WEBHOOK_FUNCTION_ID ? <ExportWebhookConfiguration /> : null}
        {action.functionId === EXPORT_TO_ZAPIER_FUNCTION_ID ? <ExportZapierConfiguration /> : null}
      </TriggerProvider>
    </Flex>
  );
};

export const ExportPanel = memo(IExportPanel) as typeof IExportPanel;
